/**
 * @generated SignedSource<<8a065421f620e6f54d8c09a7bc310d48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type scmpArticleSpeechConfigQuery$variables = Record<PropertyKey, never>;
export type scmpArticleSpeechConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type scmpArticleSpeechConfigQuery = {
  response: scmpArticleSpeechConfigQuery$data;
  variables: scmpArticleSpeechConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_article_speech"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_article_speech\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "scmpArticleSpeechConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "scmpArticleSpeechConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6382d65dc77a37b859a87b5ead0567e3",
    "id": null,
    "metadata": {},
    "name": "scmpArticleSpeechConfigQuery",
    "operationKind": "query",
    "text": "query scmpArticleSpeechConfigQuery {\n  appConfig(filter: {entityId: \"scmp_pwa_article_speech\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb79bd0671f0b5a9d8985e9545e060d9";

export default node;
